import moment from 'moment';

import { formatCurrency } from '../currencyMask';

export default function createLoanInsuranceBillLabel(bill) {
  if (bill.id === null) {
    return bill.label;
  }

  return `${bill?.pixel_bill_number} - ${bill?._vendor?.name}${
    bill?.due_date ? ` - ${moment(bill.due_date).format('M/D/YY')}` : ''
  }${
    bill?._amount?.total
      ? ` - $${formatCurrency(bill?._amount?.total)}`
      : '- $0.00'
  }${bill?.status ? ` (${bill?.status})` : ''}`;
}
